import axios from 'axios';
import store from '../store';  // Ensure the store is properly imported

const API_BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/article`;

// Set up request interceptor to attach token
axios.interceptors.request.use(config => {
    const state = store.getState();  // Get current state from Redux store
    const token = state.token;       // Access the token from the state
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;  
    }
    return config;
}, error => {
    return Promise.reject(error);
});




export const createArticle = (articleData) => axios.post(`${API_BASE_URL}/createarticle`, articleData);
export const getArticleById = (id) => axios.get(`${API_BASE_URL}/getarticle/${id}`);
export const getArticleMovements = (codeArt, config = {}) => axios.get(`${API_BASE_URL}/movements/${encodeURIComponent(codeArt)}`, config);
export const updateArticle = (id, articleData) => axios.put(`${API_BASE_URL}/updatearticle/${id}`, articleData);
export const deleteArticle = (id) => axios.delete(`${API_BASE_URL}/deletearticle/${id}`);
export const getAllArticles = async (params = {}) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/getallarticles`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const bulkUploadArticles = (formData) => axios.post(`${API_BASE_URL}/bulk-upload`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });

export const bulkUpdateZoneEtage = (articlesData) => axios.post(`${API_BASE_URL}/bulk-update-zone-etage`, articlesData);

export const bulkUpdatePrices = async (articlesData) => {
  try {
    const response = await axios.post(`${API_BASE_URL}/bulk-update-prices`, { articles: articlesData });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getArticlesZoneEtage = async (params = {}) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/get-zone-etage`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const listArticleDBFFiles = () => axios.get(`${API_BASE_URL}/dbf/list`);
export const previewArticlesFromDBF = (fileName) => axios.post(`${API_BASE_URL}/dbf/preview-articles`, { fileName });
export const importArticlesFromDBF = (articles) => axios.post(`${API_BASE_URL}/dbf/import-articles`, { articles });

export const getArticleStocks = async (codeArt) => {
  try {
    const response = await axios.get(`${API_BASE_URL}/stocks/${codeArt}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};
